import { Box, MenuItem, Stack, TextField } from "@mui/material";

const SortPanel = ({ filter, setFilter }) => {

  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <TextField
          label="Order by"
          variant="outlined"
          select
          fullWidth
          value={filter.order}
          onChange={(e)=>setFilter({...filter,order:e.target.value})}
          autoComplete="new-password"
        >
          <MenuItem value="">None</MenuItem>
          <MenuItem value="id">ID</MenuItem>
          <MenuItem value="-id">ID descending</MenuItem>
          <MenuItem value="grant_total">Grand total </MenuItem>
          <MenuItem value="-grant_total">Grand total descending</MenuItem>
          <MenuItem value="qty">Qty</MenuItem>
          <MenuItem value="-qty">Qty descending</MenuItem>
          
        </TextField>
      </Stack>
    </Box>
  );
};

export default SortPanel;
